import { graphql } from "@/gql";

export const createSupplierInsuranceOptionMutation = graphql(`
  mutation CreateSupplierInsuranceOption(
    $input: CreateSupplierInsuranceOptionInput!
  ) {
    createSupplierInsuranceOption(input: $input) {
      id
      name
      is_default
      bond_amount
      standard_liability_amount
      liability_reduction_options
      created_at
      updated_at
      supplier {
        id
        currency
      }
    }
  }
`);

export const updateSupplierInsuranceOptionMutation = graphql(`
  mutation UpdateSupplierInsuranceOption(
    $id: ID!
    $input: UpdateSupplierInsuranceOptionInput!
  ) {
    updateSupplierInsuranceOption(id: $id, input: $input) {
      ...SupplierInsuranceOptionRecordFields
    }
  }
`);

export const deleteSupplierInsuranceOptionMutation = graphql(`
  mutation DeleteSupplierInsuranceOption($id: ID!) {
    deleteSupplierInsuranceOption(id: $id) {
      id
    }
  }
`);
